import { computed } from 'vue';
import { useI18n } from '@/plugins/i18n';
import * as rule from '@/common/lib/form-valid';
import type { ValidationSuite } from '@/common/lib/form-valid';
import type { GuestTicketForm } from '@/components/OpenRequestModal/openRequestForm.types';
import {
  createGuestTicketFormValidationSuite,
  fieldErrorMessage,
  type GuestTicketFormValidationCtx,
} from './guestFormValidation';

export const useGuestTicketFormValidation = () => {
  const { t } = useI18n();

  const guestTicketFormSuite = computed(() => createGuestTicketFormValidationSuite(t));

  const validateGuestTicketForm = async (form: GuestTicketForm, ctx: GuestTicketFormValidationCtx) =>
    rule.validateForm(
      form as unknown as Record<string, unknown>,
      guestTicketFormSuite.value as unknown as ValidationSuite<Record<string, unknown>, GuestTicketFormValidationCtx>,
      ctx
    );

  return {
    validateGuestTicketForm,
    fieldErrorMessage,
  };
};

export type { GuestTicketFormValidationCtx } from './guestFormValidation';
export { fieldErrorMessage } from './guestFormValidation';
